// extracted by mini-css-extract-plugin
module.exports = {"container":"UsersContainer_container__cn-QN","delete":"UsersContainer_delete__2zJcl"};